<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useInstallPromotion } from '../composables/useInstallPromotion.ts'

const { t: translate } = useI18n()
const { promotionMode, isPrompting, showsIosInstructions, triggerInstall, dismissPromotion } =
  useInstallPromotion()
</script>

<template>
  <v-sheet
    v-if="promotionMode !== 'none'"
    class="install-promotion pa-4"
    color="surface"
    border
    elevation="4"
    role="region"
    data-testid="install-promotion"
    :aria-label="translate('install.installPromotion')"
  >
    <div class="d-flex align-start ga-3">
      <v-icon icon="mdi-cellphone-arrow-down" color="primary" size="28" aria-hidden="true" />
      <div class="flex-grow-1">
        <p class="text-subtitle-2 font-weight-medium mb-1">
          {{ translate('install.installThisApplication') }}
        </p>
        <p class="text-body-2 text-medium-emphasis mb-0">
          {{ translate('install.installBenefits', { productName: translate('product.name') }) }}
        </p>

        <template v-if="promotionMode === 'manual'">
          <ol class="install-promotion__steps text-body-2 text-medium-emphasis mt-2 mb-0">
            <template v-if="showsIosInstructions">
              <li data-testid="install-manual-step">{{ translate('install.iosOpenShareMenu') }}</li>
              <li>{{ translate('install.iosChooseAddToHomeScreen') }}</li>
              <li>{{ translate('install.iosConfirmAdd') }}</li>
            </template>
            <template v-else>
              <li data-testid="install-manual-step">
                {{ translate('install.openBrowserMenu') }}
              </li>
              <li>{{ translate('install.chooseInstallOrAddToHomeScreen') }}</li>
            </template>
          </ol>
        </template>
      </div>
      <v-btn
        icon="mdi-close"
        variant="text"
        density="comfortable"
        data-testid="dismiss-install-promotion"
        :aria-label="translate('install.dismissInstallPromotion')"
        @click="dismissPromotion"
      />
    </div>

    <v-btn
      v-if="promotionMode === 'native'"
      color="primary"
      class="mt-3"
      block
      data-testid="install-application"
      :loading="isPrompting"
      @click="triggerInstall"
    >
      {{ translate('install.install') }}
    </v-btn>
  </v-sheet>
</template>

<style scoped>
.install-promotion {
  position: fixed;
  z-index: 2000;
  right: 16px;
  bottom: 16px;
  left: 16px;
  max-width: 420px;
  margin-left: auto;
  border-radius: 12px;
}

.install-promotion__steps {
  padding-left: 20px;
}
</style>
